import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './index.module.sass';

import getGlobal from '../../../Queries/getGlobal';
export default function ChooseParcel({ state = '', callback = () => {}, selected = '' }) {
  const { t } = useTranslation(['reshipments']);
  const [paqueterias, setPaqueterias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paqueteria, setPaqueteria] = useState(selected);

  const changeValue = (e) => {
    setPaqueteria(e.target.value);
    callback(e.target.value);
  };

  const getPaqueterias = useCallback(async () => {
    setLoading(true);
    const paqueterias = await getGlobal({
      tmbservice: 'getPaqueterias',
      jsonBody: {
        estado: state || '',
      },
    });

    const {
      typeMessage: typeMessagePaq = '',
      message: messagePaq = '',
      dataDetallePaqueteria = [],
    } = paqueterias;

    setLoading(false);

    if (messagePaq !== '' && typeMessagePaq === 'error') {
      alert(messagePaq);
      return;
    }

    setPaqueterias(dataDetallePaqueteria);
  }, [state]);

  useEffect(() => {
    getPaqueterias();
  }, [getPaqueterias]);

  return (
    <div>
      <div className={styles.parcelTitle}>Paquetería</div>
      {!loading && (
        <div className={styles.parcelOptions}>
          <select
            className={`${styles.inputSelect} ${styles.inputSelectParcel}`}
            onChange={(e) => changeValue(e)}
            value={paqueteria}>
            <option value=''>{t('shipping')}</option>
            {paqueterias.length > 0 &&
              paqueterias.map((val, key) => {
                return (
                  <option key={key} value={val.paqueteria}>
                    {val.paqueteria}
                  </option>
                );
              })}
          </select>
        </div>
      )}
    </div>
  );
}
